<template>
  <div
    class="project-items-container"
    v-bind:class="[`page-${item.post_title.replace(' ', '-').toLowerCase()}`]"
  >
    <div
      class="project-header"
      :style="{ backgroundImage: `url(${item.acf.header_image.sizes.large})` }"
    >
      <div class="logo-container">
        <img
          v-if="item.acf.brand_logo"
          class="brand-logo"
          :src="item.acf.brand_logo"
          :alt="item.post_title"
        />
      </div>
    </div>

    <ProjectNav v-if="item.post_title !== 'RECUR'"></ProjectNav>

    <div class="project-details">
      <h4 class="text-uppercase">{{ item.acf.category }}</h4>
      <p v-html="widont(item.acf.long_description)"></p>
      <h3
        class="section-header section-header--case-study text-center"
        v-if="item.post_title === 'RECUR'"
        v-html="widont(item.acf.oneoff_title)"
      ></h3>
    </div>

    <ProjectNav v-if="item.post_title === 'RECUR'"></ProjectNav>

    <div class="project-items">
      <div
        v-for="(group, index) in item.acf.detail_groups"
        v-bind:key="index"
        class="project-group"
      >
        <h2 class="group-header text-center">{{ group.group_title }}</h2>
        <div
          v-for="(section, index) in group.group_items"
          v-bind:key="index"
          class="project-section"
          v-bind:class="[`columns-${section.number_of_columns}`]"
        >
          <h3
            class="section-header text-center"
            v-html="widont(section.section_title)"
          ></h3>
          <div
            v-for="(item, index) in section.section_items"
            v-bind:key="index"
            class="project-item"
          >
            <img v-if="!item.gif && !item.mp4" :src="item.image" />
            <img v-if="item.gif && !item.mp4" v-lazy="item.gif" />
            <video v-if="item.mp4" autoplay loop muted playsinline>
              <source :src="item.mp4" type="video/mp4" />
              <source v-if="item.webm" :src="item.webm" type="video/webm" />
            </video>
            <div class="border-overlay"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="project-nav bottom">
      <div class="container" v-if="item.post_title === 'RECUR'">
        <div>
          <router-link to="/project/grubhub" class="btn btn--small">
            <span>View Professional Work</span>
          </router-link>
        </div>
        <!-- <div>
          <a
            href="https://projects.invisionapp.com/prototype/RECUR-Animated-Prototype-ck8jngabf0017pc01yixffxwq/play/69123471"
            class="btn btn--small btn--tertiary"
            target="_blank"
            >View Prototype</a
          >
        </div> -->
        <div>
          <a v-on:click="toTop()" class="btn btn--small btn--dark"
            >Back to Top</a
          >
        </div>
      </div>
    </div>

    <ProjectNav v-if="item.post_title !== 'RECUR'"></ProjectNav>
  </div>
</template>

<script>
import ProjectNav from './ProjectNav.vue';
import Widont from '../mixins/Widont';

export default {
  name: 'ProjectViewItem',
  mixins: [Widont],
  components: {
    ProjectNav
  },
  props: ['item'],
  data: () => {
    return {
      itemsArray: [],
      currentIndex: 0,
      currentProjectId: 0
    };
  },
  created() {
    for (let i = 0; i < this.$root.projectsData.length; i++) {
      const el = this.$root.projectsData[i];
      this.itemsArray[i] = el.post_name;
    }

    this.currentProjectId = this.item.post_name;
    this.currentIndex = this.itemsArray.indexOf(this.currentProjectId);
  },
  methods: {
    next: function(e) {
      e.preventDefault();
      this.currentIndex++;
      if (this.currentIndex > this.$root.projectsData.length - 1)
        this.currentIndex = 0;

      let newRoute =
        '/project/' + this.itemsArray[this.currentIndex].toString();
      this.$router.push(newRoute);
    },
    prev: function(e) {
      e.preventDefault();
      this.currentIndex--;
      if (this.currentIndex < 0)
        this.currentIndex = this.$root.projectsData.length - 1;

      let newRoute =
        '/project/' + this.itemsArray[this.currentIndex].toString();
      this.$router.push(newRoute);
    },
    toTop: function() {
      window.scrollTo(0, 0);
      // window.scroll({
      //   top: 0,
      //   left: 0,
      //   behavior: 'smooth'
      // });
    },
    getTitle: function() {
      return this.item.post_title;
    }
  }
};
</script>
